import loadable from '@loadable/component';
import FullPageLoader from '../../components/UIElements/Loader/fullPageLoader';

export const NCALoginLayout = loadable(() => import('./ncaLogin.layout'), {
  fallback: <FullPageLoader />,
});
export const NcaStepLayout = loadable(() => import('./ncaAuth'), {
  fallback: <FullPageLoader />,
});
